import React from "react";
import { useEffect } from "react";
import { Loader, Flex, ButtonGroup, Button, View, useTheme } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import { statusOk, status200, API_URL, identityFrontUrl, errors } from "../config/config";
import { EsTexts } from "../config/texts";
import MessageComponent from "./Message";
import { backgroundColor } from "../config/config";

function FaceLiveness({ faceLivenessAnalysis }) {
  const [loading, setLoading] = React.useState(true);
  const [sessionId, setSessionId] = React.useState(null)
  const [language] = React.useState('es');
  const [hasError, setHasError] = React.useState(false);
  const [error, setError] = React.useState(false);
  const { tokens } = useTheme();

  const url = new URL(document.URL);
  const pathName = url.pathname.split("/").join("");
  useEffect(() => {
    /*
     * API call to create the Face Liveness Session
     */
    const fetchCreateLiveness = async () => {

      if (pathName.length === 0) {
        setHasError(true)
      }
      let result = await fetch(API_URL + 'create-session/' + pathName)
        .then((response) => response.json());
      if (result.status === statusOk) {
        const { data } = result
        setSessionId(data.sessionId)
        setLoading(false);
      }else{
        if(result.code === errors.CODE_NOT_FOUND){
          window.location.href=`${identityFrontUrl}${pathName}?advanceStep=${pathName}`
        }else{
          setHasError(true);
        }

      }
    };
    fetchCreateLiveness();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /*
 * Get the Face Liveness Session Result
 */
  const handleAnalysisComplete = async () => {
    /*
     * API call to get the Face Liveness Session result
     */

    let response = await fetch(API_URL + 'get-session-results/' + pathName,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ sessionId: sessionId })
      }
    ).then((response) => {
      if (response.status === status200) {
        return response.json();
      } else {
        setHasError(true)
        return response;
      }
    });
    if (response.status === statusOk) {
      const { data } = response;
      faceLivenessAnalysis(data)
    }
  };

  const dictionary = {
    // use default strings for english
    en: null,
    es: EsTexts,
  };

  return (
    <>
      {
        hasError ?
          <MessageComponent body={'Ha ocurrido un error inesperado'} type={'error'}>
            <ButtonGroup justifyContent="center" >
              <Button className="reference-button" style={{ zIndex: 1000 }} backgroundColor={backgroundColor} onClick={() => window.location.reload()} isFullWidth={true} marginBottom={tokens.space.large} >
                Reintentar
              </Button>
            </ButtonGroup>
          </MessageComponent >

          : loading ? (
            <Loader />
          ) : (
            <Flex
              direction="row"
              justifyContent="center"
              alignItems="center"
              alignContent="flex-start"
              wrap="nowrap"
              gap="1rem"
            >
              <View
                as="div"
                maxHeight="600px"
                height="600px"
                width="740px"
                maxWidth="740px"
              >
                <FaceLivenessDetector
                  sessionId={sessionId}
                  region="us-east-1"
                  onAnalysisComplete={handleAnalysisComplete}
                  displayText={dictionary[language]}
                  onError={(error) => {
                    console.error('try reload', error);
                    setError(error)
                  }}
                />
                {
                  error &&
                  <ButtonGroup justifyContent="center" >
                    <Button className="reference-button" style={{ zIndex: 1000 }} backgroundColor={backgroundColor} onClick={() => window.location.reload()} isFullWidth={true} marginBottom={tokens.space.large} >
                      Reintentar
                    </Button>
                  </ButtonGroup>
                }
              </View>
            </Flex>
          )
      }
    </>
  );
}

export default FaceLiveness;
